"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _Box = _interopRequireDefault(require("../Box"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Stack = _interopRequireDefault(require("../Stack"));

var _Spacer = _interopRequireDefault(require("../Spacer"));

var _CircleCheckmark = _interopRequireDefault(require("../CircleCheckmark"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SelectableCard(props) {
  let {
    selected,
    disabled,
    readonly,
    title,
    sub,
    desc,
    onPress,
    baseColor = "primary",
    ...spaceProps
  } = props;
  let cardBg = disabled ? "common.white" : `${baseColor}.light900`;
  let textColor = selected ? "green.main" : "common.black";
  let subTextColor = selected ? "green.main" : "red.main";
  let handler = disabled || readonly ? undefined : onPress;
  return /*#__PURE__*/_react.default.createElement(_Box.default, _extends({
    style: {
      width: "100%",
      opacity: disabled ? 0.4 : 1
    },
    p: "m",
    br: "m",
    bg: cardBg
  }, spaceProps, {
    // @ts-ignore
    onPress: handler,
    as: _reactNative.TouchableOpacity
  }), /*#__PURE__*/_react.default.createElement(_Stack.default, {
    distribution: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Stack.default, null, !readonly && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CircleCheckmark.default, {
    isSelected: selected
  }), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    size: "m"
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: textColor
  }, title)), sub && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    ff: "mainBold",
    fs: "s",
    color: subTextColor
  }, sub)), desc && /*#__PURE__*/_react.default.createElement(_Box.default, {
    pt: "m"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    ff: "mainBold",
    fs: "s",
    alignment: "center",
    color: "text.hint"
  }, desc)));
}

var _default = SelectableCard;
exports.default = _default;